import script from "./AddStudentList.vue?vue&type=script&setup=true&lang=js"
export * from "./AddStudentList.vue?vue&type=script&setup=true&lang=js"

import "./AddStudentList.vue?vue&type=style&index=0&id=32ebd766&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32ebd766"]])

export default __exports__